import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import DateInput from "./DateInput";

export default function AssignToSimilarDateRangeModal({
  open,
  dateFrom,
  dateTo,
  onClose,
  onApply,
}) {
  const [from, setFrom] = useState(dateFrom || "");
  const [to, setTo] = useState(dateTo || "");

  useEffect(() => {
    if (open) {
      setFrom(dateFrom || "");
      setTo(dateTo || "");
    }
  }, [open, dateFrom, dateTo]);

  if (!open) return null;

  const modal = (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 z-[50001] flex items-center justify-center"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="bg-white rounded shadow-xl w-full max-w-md p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold mb-4">Date Range</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-xs text-gray-600 mb-1">
              Start Date <span className="text-red-500">*</span>
            </label>
            <DateInput
              value={from}
              onChange={setFrom}
              className="border px-2 py-1 rounded w-full text-sm"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600 mb-1">
              End Date <span className="text-red-500">*</span>
            </label>
            <DateInput
              value={to}
              onChange={setTo}
              className="border px-2 py-1 rounded w-full text-sm"
            />
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border rounded text-sm"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={!from || !to}
            onClick={() => onApply({ dateFrom: from, dateTo: to })}
            className="px-4 py-2 bg-red-600 text-white rounded text-sm disabled:opacity-50"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document !== "undefined" && ReactDOM?.createPortal) {
    return ReactDOM.createPortal(modal, document.body);
  }
  return modal;
}
